import React from 'react'
import {Panel, Row, Col,} from 'rsuite'

function DashboardStats({ pending, total, blocked, removed }) {
  return (
    <div>
   
  <Row gutter={24} className="mb-8">
    <Col md={6} sm={12} xs={24}>
      <Panel className="bg-white" bordered>
        <div>
          <h3 className="text-lg font-semibold mb-2 text-gray-900">Pending Reports</h3>
          <p className="text-gray-600 text-sm mb-4">Reports awaiting review</p>
          <div className="flex items-center">
            <span className="text-2xl font-bold text-gray-900">{pending}</span>
            <span className="bg-red-100 text-red-700 rounded-lg px-2 py-1 ml-3 text-sm font-medium">
              Needs your attention
            </span>
          </div>
        </div>
      </Panel>
    </Col>
    <Col md={6} sm={12} xs={24}>
      <Panel className="bg-white" bordered>
        <div>
          <h3 className="text-lg font-semibold mb-2 text-gray-900">Total Reports</h3>
          <p className="text-gray-600 text-sm mb-4">All reported posts</p>
          <span className="text-2xl font-bold text-gray-900">{total}</span>
        </div>
      </Panel>
    </Col>
    <Col md={6} sm={12} xs={24}>
      <Panel className="bg-white" bordered>
        <div>
          <h3 className="text-lg font-semibold mb-2 text-gray-900">Blocked Users</h3>
          <p className="text-gray-600 text-sm mb-4">Currently suspended accounts</p>
          <span className="text-2xl font-bold text-gray-900">{blocked}</span>
          <span className="bg-red-100 text-red-700 rounded-lg px-2 py-1 ml-3 text-sm font-medium">
            Blocked
          </span>
        </div>
      </Panel>
    </Col>
    <Col md={6} sm={12} xs={24}>
      <Panel className="bg-white" bordered>
        <div>
          <h3 className="text-lg font-semibold mb-2 text-gray-900">Removed Posts</h3>
          <p className="text-gray-600 text-sm mb-4">Posts removed this month</p>
          <span className="text-2xl font-bold text-gray-900">{removed}</span>
        </div>
      </Panel>
    </Col>
  </Row>


    </div>
  )
}

export default DashboardStats

